/* eslint-disable prettier/prettier */
import { useMemo } from 'react';
import { allCountries } from 'country-telephone-data';

type CountryCode = {
    code: string;
    name: string;
};

// Memoize the country list outside the hook to avoid unnecessary recalculations
const memoizedCountries: CountryCode[] = allCountries.map((countryObj) => ({
    code: countryObj.dialCode,
    name: countryObj.iso2.toUpperCase(), // matching by name now instead of iso2
}));

/**
 * Custom hook to get country code by country name.
 * Returns '' if countryName is blank, null, undefined, or not found.
 */
export const useCountryCodeByName = (countryName?: string | null): CountryCode | '' => {
    return useMemo(() => {
        if (!countryName || typeof countryName !== 'string' || countryName.trim() === '') {
            return '';
        }
        const normalized = countryName.trim().toUpperCase();
        const match: any = memoizedCountries.find(
            (country) => country.name.toUpperCase() === normalized
        );

        return match?.code || '';
    }, [countryName]);
};
